import React, { useEffect, useState } from "react";

export const FadeCarousel = ({ images = [], interval = 3800 }) => {
  const [i, setI] = useState(0);

  useEffect(() => {
    if (images.length < 2) return;
    const id = setInterval(() => setI((p) => (p + 1) % images.length), interval);
    return () => clearInterval(id);
  }, [images.length, interval]);

  return (
    <div
      className="relative w-full aspect-[3/4] overflow-hidden border border-white/10 bg-[#0d0d0d]"
      data-testid="fade-carousel"
    >
      {images.map((src, idx) => (
        <img
          key={idx}
          src={src}
          alt="Cervezas GARAJE"
          className="absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out"
          style={{ opacity: idx === i ? 1 : 0 }}
        />
      ))}
    </div>
  );
};
